import { gql } from '@apollo/client'
import nationalContractReferenceWithType from './fragments/nationalContractReferenceWithType.fragment'

export const UPDATE_SELECTABLE_NATIONAL_CONTRACT_REFERENCE_LEVELS = gql`
  mutation UpdateSelectableNationalContractReferenceLevels($input: UpdateNationalContractReferenceInput!) {
    updateSelectableNationalContractReferenceLevels(input: $input) {
      ...NationalContractReferenceWithType
    }
  }
  ${nationalContractReferenceWithType}
`

export const IMPORT_SELECTABLE_NATIONAL_CONTRACT_REFERENCE_LEVELS = gql`
  mutation ImportSelectableNationalContractReferenceLevels($input: ImportNationalContractReferenceInput!) {
    importSelectableNationalContractReferenceLevels(input: $input) {
      ...NationalContractReferenceWithType
    }
  }
  ${nationalContractReferenceWithType}
`
